import { useInjectCss } from '@epilot/concorde-elements'
import type {
  ConcordeCustomFontSource,
  ConcordeTypography
} from '@epilot/concorde-elements'
import type { Journey } from '@epilot/journey-logic-commons'
import { useMemo } from 'react'

import { fonts } from './fonts'

const DEFAULT_FONT_SOURCE: ConcordeCustomFontSource[] = []

export const useFontInjection = (journey: Journey) => {
  const fontSource =
    (journey.design?.theme?.typography as ConcordeTypography | undefined)
      ?.fontSource ?? DEFAULT_FONT_SOURCE

  const css = useMemo(() => {
    return [...fontSource, ...fonts]
      .map((font) => {
        const {
          fontFamily,
          fontStyle = 'normal',
          fontWeight = 400,
          src,
          fontDisplay = 'swap'
        } = font

        return `
          @font-face {
            font-family: '${fontFamily}';
            font-style: ${fontStyle};
            font-weight: ${fontWeight};
            src: ${src};
            font-display: ${fontDisplay};
          }
        `
      })
      .join('\n')
  }, [fontSource])

  useInjectCss('journey-font-injection', css)
}
